<form odxForm [formGroup]="form" odxLayout="flex gap-none" [readonly]="readonly" class="flex-column scroll h-100">
  @for (service of services; track service.id) {
    <div class="service-editor-item">
      <div odxLayout="flex" class="form-item-header">
        <odx-checkbox [formControlName]="service.checkboxControlName" [attr.data-testid]="service.checkboxTestId">
          {{ service.checkboxLabel }}
        </odx-checkbox>
        @if (showPrice && service.priceControlName) {
          <odx-form-field>
            <input
              [value]="formatPriceValue(form.get(service.priceControlName!)?.value)"
              [placeholder]="pricePlaceholder"
              type="text"
              odxFormFieldControl
              (blur)="processPriceValue($event, service.priceControlName)"
              [attr.data-testid]="service.priceTestId"
            />
          </odx-form-field>
        } @else {
          <odx-form-field class="header-slot-placeholder" aria-hidden="true">
            <input odxFormFieldControl tabindex="-1" />
          </odx-form-field>
        }
      </div>
      <odx-form-field label="Anmerkungen" i18n-label="@@productList.services.remarks.label">
        <textarea
          [formControlName]="service.notesControlName"
          placeholder="Anmerkungen"
          i18n-placeholder="@@productList.services.remarks.placeholder"
          odxFormFieldControl
          [attr.data-testid]="service.notesTestId"
        ></textarea>
      </odx-form-field>
    </div>
  }
</form>
